import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { ThemeService } from './services/theme.service';

@Component({
  standalone: false,
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
})
export class AppComponent {
  title = 'E-CommerceAdmin';

  constructor(private route: Router, _theme: ThemeService) {
    if (!localStorage.getItem('access_token')) {
      this.route.navigateByUrl('/login');
    }
  }
}
